import { useMemo } from 'react';

import { fromPromise } from 'xstate5';

import { type DietaryPreferencesMachineImplementations } from '@sg/shared-fe/features/menu';

import { useUpdateDietaryPreferencesMutation } from './graphql/CustomerDietaryPreferences.generated';
import { getDietaryPreferencesList } from './helpers';

// ─────────────────────────────────────────────────────────────────────────────

export const useUpdateDietaryPreferencesActor = () => {
  const [, updatePreferences] = useUpdateDietaryPreferencesMutation();

  return useMemo<UpdateCustomerDietaryPreferences>(
    () =>
      fromPromise(async (args) => {
        const { input: restrictions } = args;

        const dietaryRestrictions = getDietaryPreferencesList(restrictions);

        const { error } = await updatePreferences({
          input: { dietaryRestrictions },
        });

        // ─── Error State ─────────────────────────────

        if (error) {
          throw new Error('Failed to update customer dietary preferences');
        }
      }),
    [updatePreferences],
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type UpdateCustomerDietaryPreferences = NonNullable<
  NonNullable<DietaryPreferencesMachineImplementations['actors']>['updateRemotePreferences']
>;
